var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-pending-tickets"}},_vm._l((_vm.ticketCategories),function(category){return _c('TicketsCategory',{key:category.id,ref:"categories",refInFor:true,attrs:{"category":category}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }